module.exports = __webpack_public_path__ + "r-v3/img/exam_mark_correct.4b8f9be2.svg";